<template>
	<div class="layout-container" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
		<!-- 侧边栏 -->
		<Sidebar :collapsed="sidebarCollapsed" />
		
		<!-- 主要内容区域 -->
		<div class="main-container">
			<!-- 头部 -->
			<Header @toggle-sidebar="toggleSidebar" />
			
			<!-- 内容区域 -->
			<div class="content-wrapper">
				<slot></slot>
			</div>
		</div>
		
		<!-- 移动端遮罩层 -->
		<div v-if="showMask" class="sidebar-mask" @click="toggleSidebar"></div>
	</div>
</template>

<script>
import Header from '@/components/Header/index'
import Sidebar from '@/components/Sidebar/index'

export default {
	name: 'Layout',
	components: {
		Header,
		Sidebar
	},
	data() {
		return {
			sidebarCollapsed: false
		}
	},
	computed: {
		showMask() {
			// 在移动端且侧边栏展开时显示遮罩
			return window.innerWidth <= 576 && !this.sidebarCollapsed
		}
	},
	mounted() {
		// 监听窗口大小变化
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		toggleSidebar() {
			this.sidebarCollapsed = !this.sidebarCollapsed
		},
		
		handleResize() {
			// 在移动端默认收起侧边栏
			if (window.innerWidth <= 576) {
				this.sidebarCollapsed = true
			} else {
				this.sidebarCollapsed = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.layout-container {
	position: relative;
	width: 100%;
	min-height: 100vh;
}

.main-container {
	margin-left: 200px; // 侧边栏宽度
	min-height: 100vh;
	background-color: #f5f7fa;
}

.content-wrapper {
	padding-top: 60px; // 头部高度
	min-height: calc(100vh - 60px);
}

// 侧边栏遮罩层
.sidebar-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 1998;
	transition: opacity 0.3s ease;
}

// 侧边栏折叠状态
.sidebar-collapsed {
	::v-deep .sidebar-container {
		transform: translateX(-100%);
	}
}

// 响应式设计
@media (max-width: 768px) {
	.main-container {
		margin-left: 180px;
	}
}

@media (max-width: 576px) {
	.main-container {
		margin-left: 0;
	}
	
	.layout-container {
		::v-deep .sidebar-container {
			position: fixed;
			top: 0;
			left: 0;
			height: 100vh;
			z-index: 1999;
			transform: translateX(-100%);
			transition: transform 0.3s ease;
		}
		
		&:not(.sidebar-collapsed) {
			::v-deep .sidebar-container {
				transform: translateX(0);
			}
		}
	}
}
</style> 